import React from "react";
import { Helmet } from "react-helmet";

export const GlamMag = () => {
  return (
    <div className={"p-2 p-lg-5"}>   
      <h1>GlamMag</h1>
    </div>
  );
};
